import React, { useEffect } from "react";
import styled from "styled-components";
import { observer } from "mobx-react";
import { getStatFgs } from '../../../http/manager';
import * as echarts from 'echarts';

const FunnelPlot: React.FC = () => { 
    useEffect(()=> {
        getData();
        return;
    }, [])
    const getData = ()=> {
        getStatFgs({}).then((res:any)=> {
            let nameList = [];
            if(res.data.length > 0) {
                for(let i=0, len=res.data.length; i<len; i++) {
                    nameList.push(res.data[i].name);
                }
            }
            let myChart = echarts.init(document.getElementById('rechartGraph1'));
            myChart.setOption({
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c}%'
                },
                legend: {
                    data: nameList
                },
                series: [
                    {
                        name: '数量',
                        type: 'funnel',
                        left: '10%',
                        top: 30,
                        bottom: 0,
                        width: '80%',
                        min: 0,
                        max: 100,
                        minSize: '0%',
                        maxSize: '100%',
                        sort: 'descending',
                        gap: 2,
                        label: {
                            show: true,
                            position: 'inside',
                            color: '#fff'
                        },
                        labelLine: {
                            length: 10,
                            lineStyle: {
                                width: 1,
                                type: 'solid'
                            }
                        },
                        itemStyle: {
                            normal: {
                                borderColor: '#fff',
                                borderWidth: 1,
                                color: function (colors:any) {
                                    let colorList = [
                                        '#7585A2',
                                        '#73DEB3',
                                        '#73A0FA'
                                    ];
                                    return colorList[colors.dataIndex];
                                }
                            }
                        },
                        emphasis: {
                            label: {
                                fontSize: 20
                            }
                        },
                        data: res.data
                    }
                ]
            })
        })
    }
    return (
        <GraphContainer>
            <div id='rechartGraph1' style={{ width: '100%', height: '100%' }}></div>
        </GraphContainer>
    )
}

export default observer(FunnelPlot);

const GraphContainer = styled.div`
    & {
        width: 100%;
        height: 100%;
    }
`